import type { AddPresetScope } from '../../../../addPresetApiEntry';
import { CREATE_SECTON_WITH_AI_CACHE } from '../aiSectionCreatorConsts';
import { SiteGlobalDataApiKey } from '#packages/apis';
import * as stateManagement from '#packages/stateManagement';
import { translate } from '#packages/i18n';
import type { EditorAPI } from '#packages/editorAPI';
import experiment from 'experiment';

export const clearSectionsCacheEntry = (): void => {
  const cachedData = JSON.parse(
    sessionStorage.getItem(CREATE_SECTON_WITH_AI_CACHE),
  );

  const updatedData = {
    ...cachedData,
    sections: null,
  };

  sessionStorage.setItem(
    CREATE_SECTON_WITH_AI_CACHE,
    JSON.stringify(updatedData),
  );
};

const getSiteToneOfVoice = (editorAPI: EditorAPI): string => {
  const state = editorAPI.store.getState();
  const siteToneOfVoice =
    stateManagement.userPreferences.selectors.getSiteUserPreferences(
      'toneOfVoice',
    )(state);

  return (
    siteToneOfVoice ||
    translate('ai_text_creator_chat_refine_change_tone_enthusiastic')
  ).toLowerCase();
};

export const getBusinessData = (
  scope: AddPresetScope,
): { businessName: string; businessType: string; toneOfVoice: string } => {
  const { editorAPI } = scope;
  const siteGlobalDataAPI = editorAPI.host.getAPI(SiteGlobalDataApiKey);
  const businessType = siteGlobalDataAPI.getBusinessType()?.displayName ?? '';
  const businessName = siteGlobalDataAPI.getBusinessName();
  const toneOfVoice = getSiteToneOfVoice(editorAPI);

  return {
    businessType,
    businessName,
    toneOfVoice,
  };
};

export const isHtmlToWixEnabled = experiment.isOpen('se_htmlToWixAiSection');
